import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import List from "./list";
import templates from "../../utils/templates";
import environment from "../../common/environment";

import "../../../../sass/environments.scss";

const channel = Radio.channel("global");

const DEFAULTS = {
  id: "environment-selector",
  className: "col-xs-6 col-xs-offset-3 notice",
  template: templates.find("environment_selector", "layout"),
};

class EnvironmentSelector extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      environmentList: ".environment-list",
    };
  }

  ui() {
    return {
      submitBtn: "button.submit",
    };
  }

  events() {
    return {
      "click @ui.submitBtn": "_save",
    };
  }

  childEvents() {
    return {
      toggleSubmit: "onToggleSubmit",
    };
  }

  initialize() {
    // get user's shards
    this.collection = channel.request("auth:user-shards");

    // soften view swapping
    this.regionManager.each((region) => {
      region.onBeforeShow = () => {
        region.$el.hide();
      };
      region.onShow = () => {
        region.$el.fadeIn();
      };
    });
  }

  onBeforeShow() {
    this.environmentList.show(
      new List({
        collection: this.collection,
      })
    );
  }

  onToggleSubmit(view, toggle) {
    this.ui.submitBtn.attr("disabled", !toggle);
  }

  _save() {
    const shard = this.collection.findWhere({ checked: true });

    // persist this shard as the default
    jQuery.ajax({
      context: this,
      url: environment.getEndpoint("defaultShard"),
      method: "PUT",
      contentType: "application/json",
      processData: false,
      data: JSON.stringify(shard.toJSON()),
      success() {
        // redirect home
        channel.trigger("auth:app-home");
      },
      error() {
        // show error as alert as status module has not been loaded
        alert(
          "We were unable to set your environment. Please notify your administrator."
        );
      },
    });
  }
}

export { EnvironmentSelector as default };
